import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import moment from 'moment'
import { appHeightChanged } from '../../../actions/app-actions'
import { useDispatch } from 'react-redux'


const BoughtTickets = ({ leftMargin, transactions, iframeId, orgID }) => {
    const dispatch = useDispatch()

    const location = useLocation();
    const transaction = transactions ? transactions :  location?.state?.transaction
    const [showReceipt, setShowReceipt] = useState(false)
    const [receiptHTML, setReceiptHTML] = useState()
   
    let future_tickets = []
    let past_tickets = []

    useEffect(() => {
        dipatchAppHeight()
    })

    function dipatchAppHeight() {

        dispatch(appHeightChanged(iframeId, false))
    }


    function handleReceipt(item) {
       
        setShowReceipt(true)
        setReceiptHTML(item.Receipt)
    }

    function closeReceipt() {
        setShowReceipt(false)

    }

    transaction?.Transactions.map((item) => {
        let id = moment(item.ArrDate).format('YYYY-MM-DD')
        let td = moment().format('YYYY-MM-DD')
       
        if (moment(id).isSameOrAfter(moment(td))) {
          
            future_tickets.push(item)
        }
        else past_tickets.push(item)
    })

   
   

    return (
        <main>
            {showReceipt === true ?
                <div className='receiptModal' style={{ left: leftMargin-7+'px' }}>
                    <button className='close-receipt' onClick={closeReceipt}>X</button>
                    <div className='receiptContainer' dangerouslySetInnerHTML={{ __html: receiptHTML }} >

                    </div>
                   
                </div> : null}
            <p style={{ color: orgID == 0 ? '#f1c895' : '' }} className='text'>Købte billetter</p>


       {future_tickets.length ? future_tickets.map(item => {
          return   <div className='ticketContainer'>
              <img className='movie-img' src={`https://poster.ebillet.dk/${item.PosterLarge}`} />
                    <div className='info-container'>
                       
                  <p className='movie-name'>{item.ArrName.split('-')[1] ? [item.ArrName.split('-')[0], item.ArrName.split('-')[1].split('.')[0]].join('-') : item.ArrName}</p>
                  <p className='undertext'>{item.ArrName.split('-')[1] ? item.ArrName.split('-').pop() : ''}</p>
                        <br></br>
                        <div className='qrInfoContainer' >
                          <div>
                         <p className='movie-info'> <span>Biograf:</span> <label>{item.OrgName}</label>  </p>
                         <p className='movie-info'> <span>Dato:</span> <label>{moment(item.ArrDate).format('DD')}.{moment(item.ArrDate).locale('da').format(' MMMM')}{moment(item.ArrDate).format(' YYYY')}</label>  </p>
                         <p className='movie-info'> <span>Tidspunkt:</span> <label>{moment(item.ArrDate).format('LT') }</label>  </p>
                         <p className='movie-info'> <span>Sal:</span> <label>{item.LocationName }</label>  </p>

                            <p className='movie-info'> <span>Placering:</span> <label>{ item.PlacementNice}</label>  </p>

                          </div>
                           <div className='qrContainer'>
                               <img src={`https://ebillet.dk/systemnative/barcode.asmx/QRBarCode?size=8&width=180&text=${item.BuyCode}`} width='166' height='166' />
                               <p className='ticketCount'>Gælder til {item.TicketCount}{item.TicketCount>1 ? ' billetter':' billet'} </p>
                               <button className='showReceipt' onClick={() => handleReceipt(item) }>Vis kvittering</button>
                            </div>
                      

                    </div>
                </div>
               

                </div>
               
       }) : <p className='no-ticket-text'>Du har ingen billetter til kommende forestillinger.</p>
}
            
            {past_tickets.length ?  <div className='past-text-container'> <p className='past-ticket-text'>Tidligere købte billetter</p>
                </div> : null}


            <div className='past-tickets-container' >
            {past_tickets.length ? past_tickets.map(item => {

              return <div style={{ display: 'flex', } }> 
                  <img width='105px' height='154px' src={`https://poster.ebillet.dk/${item.PosterLarge}`} />
                  <div style={{ width: '300px', padding: '8px 30px' }}>
                              <p className='ticket-count'>Du købte {item.TicketCount} {item.TicketCount > 1 ? ' billetter' : ' billet'} til</p>
                               <p className='movie-name'>{item.ArrName.split('-')[1] ? [item.ArrName.split('-')[0], item.ArrName.split('-')[1].split('.')[0]].join('-') : item.ArrName}</p>
                               <p className='undertext'>{item.ArrName.split('-')[1] ? item.ArrName.split('-').pop() : ''}</p>
                               <button className='showPastReceipt' onClick={() => handleReceipt(item)}>Vis kvittering</button>

                            </div>
                        </div>
                 
              
            }) : null}
            </div>

         
          
        </main>
    )
}

export default BoughtTickets